import { useEffect } from "react";
import { API } from "@/lib/api";

/**
 * Global singleton SSE connection. Consumers subscribe via `subscribe(handler)`.
 * Handler receives { type, ...payload }. Returns unsubscribe fn.
 */
let source = null;
const handlers = new Set();
let reconnectTimer = null;
let currentToken = null;

function connect() {
  if (source) { try { source.close(); } catch {} source = null; }
  const token = localStorage.getItem("ft_token");
  if (!token) return;
  currentToken = token;
  const url = `${API}/events/stream?auth=${encodeURIComponent(token)}`;
  const es = new EventSource(url);
  source = es;
  const dispatch = (type, data) => {
    handlers.forEach((h) => {
      try { h({ type, ...(data || {}) }); } catch {}
    });
  };
  const wire = (type) => es.addEventListener(type, (e) => {
    let payload = null;
    try { payload = JSON.parse(e.data); } catch { payload = {}; }
    dispatch(type, payload);
  });
  ["hello", "issue.created", "issue.updated", "issue.deleted", "comment.new",
   "sprint.created", "sprint.updated", "sprint.completed", "board.updated",
   "page.updated", "notification.new"].forEach(wire);
  es.onerror = () => {
    try { es.close(); } catch {}
    source = null;
    if (reconnectTimer) return;
    reconnectTimer = setTimeout(() => { reconnectTimer = null; connect(); }, 3000);
  };
}

export function ensureRealtime() {
  const token = localStorage.getItem("ft_token");
  if (!token) return;
  if (source && currentToken === token) return;
  connect();
}

export function stopRealtime() {
  if (source) { try { source.close(); } catch {} }
  source = null;
  currentToken = null;
  if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
}

export function useRealtime(handler, deps = []) {
  useEffect(() => {
    ensureRealtime();
    handlers.add(handler);
    return () => { handlers.delete(handler); };
    // eslint-disable-next-line
  }, deps);
}

export function realtimeStatus() {
  return !!source;
}
